// extracted by mini-css-extract-plugin
export default {"line":"Home_line__G6D3L"};